export const COMPANY_NAME = "서울씨엔지㈜";
export const COMPANY_ID = "105-87-35969";
export const COMPANY_CEO = "배상준";
export const COMPANY_ADDR = "서울시 마포구 가양대로 125";
export const COMPANY_EMAIL = "seoulev@seoulgas.co.kr";
export const COMPANY_CALL = "031-910-8587";
export const COPYRIGHT = "Copyright© 2022 SEOULCNG, All Rights Reserved.";
export const HELP_CALL = "1566-6373";
